import { render, staticRenderFns } from "./ColorManipulation.vue?vue&type=template&id=4f36e224&scoped=true"
import script from "./ColorManipulation.vue?vue&type=script&lang=js"
export * from "./ColorManipulation.vue?vue&type=script&lang=js"
import style0 from "./ColorManipulation.vue?vue&type=style&index=0&id=4f36e224&prod&scoped=true&lang=css"
import style1 from "./ColorManipulation.vue?vue&type=style&index=1&id=4f36e224&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f36e224",
  null
  
)

export default component.exports